import React from "react";

const LoyaltyProgramPage = () => {
  return <h2>Loyalty Program Page</h2>;
};

export default LoyaltyProgramPage;
